import * as Action from "@actions/index";
import * as Model from "@models/index";
import { useDispatch } from "@helpers/Store";

export default class Country {
  /**
   * @return function(Dispatch)->Country.list
   */
  public static async load() {
    useDispatch(Action.Location.Country.setStatus("loading"));
    try {
      const response = await new Model.Location.Country().list();
      useDispatch(Action.Location.Country.setList(response.data));
      useDispatch(Action.Location.Country.setStatus("loaded"));
      return response.data;
    } catch (Exception) {}
  }
}
